import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-50bc4c9a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "bg-[#1C1C27] min-h-screen"
};
const _hoisted_2 = {
  class: "top text-[#9faab4] !bg-[#1C1C27] leading-[34px]"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "content pb-[20px] mt-[50px]"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  key: 0,
  class: "logo"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "btn-box"
};
const _hoisted_9 = {
  key: 0,
  target: "_parent",
  href: "/PP88-V5.apk"
};
const _hoisted_10 = {
  key: 1,
  class: "flex justify-between h-full"
};
const _hoisted_11 = ["href"];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mt-[15px]"
}, null, -1));
const _hoisted_13 = {
  class: "btn-box"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "guide-text"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "guide-border"
}, null, -1));
const _hoisted_17 = {
  class: "guide-top"
};
const _hoisted_18 = {
  class: "guide-title"
};
const _hoisted_19 = {
  class: "guide-content"
};
const _hoisted_20 = {
  class: "box-text"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_22 = ["src"];
import { computed, onMounted, ref } from "vue";
import $ from "jquery";
import { useI18n } from "vue-i18n";
import { Popup as VanPopup } from "vant";
export default {
  __name: 'MobilePage',
  setup(__props) {
    const homeUrl = ref('https://m.pp88.com');
    const showLogo = ref(false);
    const showBack = ref(false);
    const {
      locale
    } = useI18n();
    function getLink(i) {
      return require(`@/assets/m/phone-${imgResource[locale.value].guideStep}${i}.jpg`);
    }
    const imgResource = {
      zh_CN: {
        service: require("@/assets/m/service.png"),
        swipe: [require("@/assets/m/phone-zh/swipe1.webp"), require("@/assets/m/phone-zh/swipe2.webp"), require("@/assets/m/phone-zh/swipe3.webp")],
        logo: require("@/assets/m/LOGO.jpg"),
        top: require("@/assets/m/top.png"),
        guide: require("@/assets/m/guide.png"),
        guideStep: 'zh/ZH_'
      },
      zh_TW: {
        service: require("@/assets/m/service.png"),
        swipe: [require("@/assets/m/phone-tw/swipe1.webp"), require("@/assets/m/phone-tw/swipe2.webp"), require("@/assets/m/phone-tw/swipe3.webp")],
        logo: require("@/assets/m/LOGO.jpg"),
        top: require("@/assets/m/top.png"),
        guide: require("@/assets/m/guide.png"),
        guideStep: 'tw/ZH_'
      },
      en_US: {
        service: require("@/assets/m/service.png"),
        swipe: [require("@/assets/m/phone-en/swipe1.webp"), require("@/assets/m/phone-en/swipe2.webp"), require("@/assets/m/phone-en/swipe3.webp")],
        logo: require("@/assets/m/LOGO.jpg"),
        top: require("@/assets/m/top.png"),
        guide: require("@/assets/m/guide.png"),
        guideStep: "en/EN_"
      },
      en_MAS: {
        service: require("@/assets/m/service.png"),
        swipe: [require("@/assets/m/phone-ms/swipe1.webp"), require("@/assets/m/phone-ms/swipe2.webp"), require("@/assets/m/phone-ms/swipe3.webp")],
        logo: require("@/assets/m/LOGO.jpg"),
        top: require("@/assets/m/top.png"),
        guide: require("@/assets/m/guide.png"),
        guideStep: "ms/MAS_"
      },
      vi_VN: {
        service: require("@/assets/m/service.png"),
        swipe: [require("@/assets/m/phone-en/swipe1.webp"), require("@/assets/m/phone-en/swipe2.webp"), require("@/assets/m/phone-en/swipe3.webp")],
        logo: require("@/assets/m/LOGO.jpg"),
        top: require("@/assets/m/top.png"),
        guide: require("@/assets/m/guide.png"),
        guideStep: "en/EN_"
      }
    };
    onMounted(() => {
      const rate = isIos.value ? 1.714 : 1.6; // 1.6 android
      if ($(window).height() < $(window).width() * rate + 50) {
        showLogo.value = false;
      }
      if (window.location.href.indexOf('show_back=1') !== -1) {
        showBack.value = true;
      }
    });
    function getRandomUrl() {
      // 定义一个包含四个URL的数组
      const urls = ['/PP88_v3.mobileconfig', '/PP88_subc.mobileconfig', '/PP88_subv.mobileconfig', '/PP88_suba.mobileconfig'];

      // 生成一个随机索引
      const randomIndex = Math.floor(Math.random() * urls.length);

      // 返回随机选中的URL
      return urls[randomIndex];
    }
    function getEnvironment() {
      let ua = navigator.userAgent;
      let result = '';
      if (/AndroidAPP/i.test(ua)) {
        result = 'ANDROIDAPPNEW';
      } else if (/AndroidH5APP/i.test(ua)) {
        result = 'ANDROIDAPP';
      } else if (/android/i.test(ua)) {
        result = 'ANDROID';
      } else if (window.navigator.standalone) {
        result = "WEBCLIP";
      } else if (/(iPhone|iPad|iPod|IOS)/i.test(ua)) {
        result = 'IOS';
      } else {
        // /microMessenger/i.test(ua)
        result = 'ANDROID';
      }
      // Toast('sdf'+ result)
      return result;
    }
    const isIos = computed(() => {
      return getEnvironment() === 'IOS' || getEnvironment() === 'WEBCLIP';
    });
    function cancel() {
      showGuide.value = false;
    }
    const showGuide = ref(false);
    function jumpHome() {
      window.parent.location.href = homeUrl.value;
    }
    function back() {
      window.history.back();
    }
    function trust() {
      setTimeout(function () {
        location.href = "embedded3.mobileprovision";
      }, 3000);
    }
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_swipe_item = _resolveComponent("van-swipe-item");
      const _component_van_swipe = _resolveComponent("van-swipe");
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [showBack.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "back",
        onClick: back
      }, [_createVNode(_component_van_icon, {
        name: "arrow-left",
        color: "var(--color-gray)"
      })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('message.appDownload')), 1)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_swipe, {
        class: "my-swipe",
        autoplay: 3000,
        "indicator-color": "white"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imgResource[_unref(locale)].swipe, (image, index) => {
          return _openBlock(), _createBlock(_component_van_swipe_item, {
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("img", {
              class: "swipe-img",
              src: image
            }, null, 8, _hoisted_5)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }), showLogo.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("img", {
        src: imgResource[_unref(locale)].logo,
        class: "logo-img"
      }, null, 8, _hoisted_7)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [!isIos.value ? (_openBlock(), _createElementBlock("a", _hoisted_9, [_createVNode(_component_van_button, {
        class: "btn-down"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('message.downloadBtn')), 1)]),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("a", {
        target: "_parent",
        onClick: _cache[0] || (_cache[0] = $event => trust()),
        href: getRandomUrl(),
        class: "flex-1 h-full"
      }, [_createVNode(_component_van_button, {
        class: "btn-down !bg-[#3750E8] !w-full h-full",
        style: {
          "background": "unset"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('message.downloadNow')), 1)]),
        _: 1
      })], 8, _hoisted_11), _unref(locale) === 'vi_VN' ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        target: "_parent",
        onClick: _cache[1] || (_cache[1] = $event => trust()),
        href: "/PP88_nav.mobileconfig",
        class: "flex-1 h-full ml-[15px]"
      }, [_createVNode(_component_van_button, {
        class: "btn-down !bg-[#17AC3C] !w-full h-full",
        style: {
          "background": "unset"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('message.downloadNow2')), 1)]),
        _: 1
      })])) : _createCommentVNode("", true)]))]), _hoisted_12, _createElementVNode("div", _hoisted_13, [_createVNode(_component_van_button, {
        class: "btn-jump",
        onClick: _cache[2] || (_cache[2] = $event => jumpHome())
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('message.jumpBtn')), 1)]),
        _: 1
      })]), isIos.value ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "install-box",
        onClick: _cache[3] || (_cache[3] = $event => showGuide.value = true)
      }, [_createElementVNode("img", {
        class: "top-img",
        src: imgResource[_unref(locale)].top
      }, null, 8, _hoisted_14), _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('message.guideText')), 1)])) : _createCommentVNode("", true)])]), _createVNode(_unref(VanPopup), {
        show: showGuide.value,
        "onUpdate:show": _cache[5] || (_cache[5] = $event => showGuide.value = $event),
        position: "bottom",
        class: "guide-popup"
      }, {
        default: _withCtx(() => [_hoisted_16, _createElementVNode("div", _hoisted_17, [_createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('message.installGuide')), 1), _createElementVNode("span", {
          class: "cancel",
          onClick: _cache[4] || (_cache[4] = $event => cancel())
        }, _toDisplayString(_ctx.$t('message.cancel')), 1)]), _createElementVNode("div", _hoisted_19, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, i => {
          return _createElementVNode("div", {
            class: "guide-box",
            key: i
          }, [_createElementVNode("span", _hoisted_20, _toDisplayString(i) + ".", 1), _hoisted_21, _createElementVNode("img", {
            class: "box-img",
            src: getLink(i)
          }, null, 8, _hoisted_22)]);
        }), 64))])]),
        _: 1
      }, 8, ["show"])], 64);
    };
  }
};